import { Box } from '@mui/material';
import type { ReactNode } from 'react';

/**
 * The controls that filter a table, directly above the table they filter.
 *
 * They used to live in the page header's `action` slot, level with the title — on the stories page that
 * put them above four statistic tiles and a warning panel, a screen away from the first row. Nothing said
 * they belonged to the table except that there was nothing else they could belong to (R0141).
 *
 * Rendered inside the table's own `<Paper>`, above its `<TableContainer>`, so the border makes the claim
 * that the position implies.
 *
 * Rules: Progress/AI Updates/Conventions/10-Back-Office-Tables.md.
 */
export const TableFilters = ({ children }: { children: ReactNode }) => (
  <Box
    sx={{
      display: 'flex',
      flexWrap: 'wrap',
      alignItems: 'center',
      gap: 2,
      px: 2,
      py: 1.75,
      borderBottom: 1,
      borderColor: 'divider',
    }}
  >
    {children}
  </Box>
);
